"use strict";

// module Partial

exports.crashWith = function () {
  return function (msg) {
    throw new Error(msg);
  };
};



//////////////////
// WEBPACK FOOTER
// ./output/Partial/foreign.js
// module id = 308
// module chunks = 0